/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Grid } from "@mui/material";
import Button from "components/generals/Button";
import { FC } from "react";
import { useTranslation } from "react-i18next";

/**
 * Props for the FormActionButtons component.
 * @interface Props
 * @property {() => void} [closeAction] - Callback when close button is clicked
 * @property {boolean} [isSubmitting] - Flag indicating if form is currently submitting
 * @property {string} [modelId] - ID of the model being edited (determines button text)
 * @property {boolean} [showSubmitButton=true] - Flag to show/hide submit button
 */
interface Props {
  closeAction?: () => void;
  isSubmitting?: boolean;
  modelId?: string;
  showSubmitButton?: boolean;
}

/**
 * Reusable form action buttons component.
 * Renders close and submit buttons with appropriate labels based on form state.
 * Submit button shows "Create" for new entities or "Save" for existing ones.
 * @param {Props} props - Component props
 * @returns {React.ReactElement} Form action buttons (close and submit)
 */
const FormActionButtons: FC<Props> = ({
  closeAction,
  isSubmitting,
  modelId,
  showSubmitButton = true,
}) => {
  const { t } = useTranslation();
  return (
    <Grid mt={2} container justifyContent="end">
      {closeAction && (
        <Grid item>
          <Button
            id="cy-close-formActionButtons"
            variant="contained"
            color="secondary"
            className="add-box-shadow"
            onClick={() => {
              closeAction();
            }}
          >
            {t("formActionButtons.close")}
          </Button>
        </Grid>
      )}

      {showSubmitButton && (
        <Grid item>
          <Button type="submit" variant="contained" color="info" disabled={isSubmitting}>
            {modelId ? t("formActionButtons.save") : t("formActionButtons.create")}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default FormActionButtons;
